import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material';
import { UserAttributeService } from '../../../../service/finzy-flex/user/user-attribute.service';
import { AttributeCode, InvestmentPreference, AttributeValue, UserAttribute, UserAttributeInterface, RISK_RANGE, SUB_PRODUCTS, MATURITY_PRODUCTS_NAME } from '../../../../model/finzy-flex/user-attribute.model';
import { Keys, StorageService } from '../../../../service/storage.service';
import { Toaster, Type } from '../../../../toaster/Toaster';
import { ProductDetails, ProductList, RiskScore } from '../../../../model/finzy-flex/product-list.model';
import { ConsentDialogComponent } from '../../investment-application-flow/steps/investment-preferences/consent-dialog/consent-dialog.component';
import { ConsentType } from '../../../../model/ConsentAudit';
import { ConsentService } from '../../../../service/consent.service';
import { ConfirmPopUpFinzyFlexComponent } from '../confirm-pop-up-finzy-flex/confirm-pop-up-finzy-flex.component';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProductType } from '../../../../model/finzy-flex/finzy-flex-config.model';
import { cloneDeep, isEqual } from 'lodash';
import { AccountService } from '../../../../service/finzy-flex/account/account.service';
import { formatNumber } from '@angular/common';
import { ConfirmationPopupWithSvgComponent } from '../confirmation-popup-with-svg/confirmation-popup-with-svg.component';
import { NCashDataUtil } from '../../../../utils/finzy-flex/nCash-data.util';
import { ProductService } from '../../../../service/finzy-flex/product/product.service';
import { ConfigService } from '../../../../service/config.service';

@Component({
	selector: 'app-user-attribute',
	templateUrl: './user-attribute.component.html',
	styleUrls: ['./user-attribute.component.scss']
})
export class UserAttributeComponent implements OnInit, AfterViewInit {
	private userAttributes: InvestmentPreference[] = [];
	private product: ProductList;
	private isPreferenceExist: boolean = true;
	private userAttributeService: UserAttributeService;
	private storageService: StorageService;
	private userId: string;
	private activatedRoute: ActivatedRoute;
	private readonly matDialog: MatDialog;
	private readonly consentService: ConsentService;
	private readonly accountService: AccountService;
	private readonly productService: ProductService;
	private readonly configService: ConfigService;
	private state$: Observable<any>;
	private isNCashModified: boolean = false;
	private isSwiftModified: boolean = false;
	private previousUserAttribute: InvestmentPreference[];
	private nCashCalculatorUtil: NCashDataUtil;
	public userAttributesForm: FormGroup;
	public userAttributesSwiftForm: FormGroup;
	public setPannel: number = -1;
	public selectedNCashType: any;
	public userPreviousNCashType: string;
	public isPreviousSwiftAvailable: boolean = true;
	public submitBar: boolean = false;
	public isSwiftEnabled: boolean = false;
	public isNCashEnabled: boolean = false;
	public isEmailEnabled: boolean = false;
	public isFinzyBoltEnabled: boolean = false;
	public dataLoader: boolean = false;
	public products: InvestmentPreference[] = [];
	public backupSwiftAttribute: InvestmentPreference[] = [];
	public userPreviousAttributes: { key: string, value: string | number }[] = [];
	public maxNCashAmount: number = 0;
	public interestOnlyAmount: number = 0;
	public customNCashAmount: number = 0;
	public disableSave: boolean = true;
	public expectedReturn = {
		F6: 0,
		F12: 0,
		F24: 0,
		F36: 0,
		F18: 0
	};
	public riskScore: RiskScore;

	public riskRangeScore = {
		"A1-A6": 1,
		"B1-B6": 3,
		"C1-C6": 5
	};
	public showFormPreferenceForm: boolean = false;
	public maxLoanAmountToggle: string = '10';
	public tenurePreferenceToggle: string = '36';
	public interestRateRiskRangeToggle: Array<string> = Object.values(RISK_RANGE);

	private panels = ['MAX_LIMIT', 'CUSTOM', 'INTEREST_ONLY'];
	constructor(activatedRoute: ActivatedRoute, formBuilder: FormBuilder, userAttributeService: UserAttributeService,
		storageService: StorageService, matDialog: MatDialog, consentService: ConsentService, accountService: AccountService, nCashCalculatorUtil: NCashDataUtil,
		productService: ProductService, configService: ConfigService) {
		this.userAttributeService = userAttributeService;
		this.storageService = storageService;
		this.matDialog = matDialog;
		this.consentService = consentService;
		this.activatedRoute = activatedRoute;
		this.accountService = accountService;
		this.productService = productService;
		this.configService = configService;
		this.nCashCalculatorUtil = nCashCalculatorUtil;
		activatedRoute.data.subscribe(data => {
			this.product = data.product;
			if (data.userAttributes?.data?.length > 0) {
				this.isFinzyBoltEnabled = !!data.userAttributes.data[0]?.automaticInvestmentsFromWallet;
				this.userAttributes = data.userAttributes.data[0]?.investmentPreferences ? data.userAttributes.data[0].investmentPreferences : [];
			}
			if (!data.userAttributes.count) {
				this.isPreferenceExist = false;
			}
		})
		this.userAttributesForm = formBuilder.group({
			nCash: formBuilder.control(null),
			frequency: formBuilder.control(null),
			date: formBuilder.control(null),
			loanPreference: formBuilder.group({
				maxLoanAmount: formBuilder.control(null),
				tenurePreference: formBuilder.control(null),
				expectedReturn: formBuilder.group({
					F6: formBuilder.control(null),
					F12: formBuilder.control(null),
					F24: formBuilder.control(null),
					F36: formBuilder.control(null),
					F18: formBuilder.control(null)
				}),
				interestRateRiskRange: [
					formBuilder.control(null),
					Validators.compose([Validators.required, Validators.minLength(2)]),
				],
			}),
		});
		this.userAttributesSwiftForm = formBuilder.group({
			fundAllocationPercent: formBuilder.array([])
		});
	}

	ngOnInit(): void {
		this.getRiskScore();
		this.userId = this.storageService.getItem(Keys.PROFILE_ID);
		this.backupSwiftAttribute = cloneDeep(this.userAttributes.filter(attr => attr.attributeCode === AttributeCode.INVESTMENT_FUND_ALLOCATION));
		this.previousUserAttribute = cloneDeep(this.userAttributes);
		this.setUserAttribute();
		this.getMaxNCashAmount();
	}

	ngAfterViewInit(): void {
		this.onNCashValueChange();
		this.state$ = this.activatedRoute.paramMap.pipe(map(() => window.history.state));
		this.state$.subscribe((data) => {
			if (data?.preferenceType == ProductType.SWIFT) {
				this.onSwiftToggle();
			}
			if (data?.preferenceType == ProductType.NCASH) {
				this.onNCashToggle();
			}
		});
	}

	private setUserAttribute() {
		this.setSwiftAttribute();
		this.setNCashAttribute();
		this.setEmailNotification();
	}

	private async getMaxNCashAmount(): Promise<void> {
		await this.nCashCalculatorUtil.getNCashDetailsWithDefaultValue()
			.then(response => {
				this.maxNCashAmount = response.data[0].ncashAmount;
			}).catch(() => { this.maxNCashAmount = 0 })
	}

	public setPannelHeader(index: number) {
		if (index == this.setPannel) return;
		this.setPannel = index;
	}

	public shouldStopFromNavigatingAway(): boolean {
		return this.submitBar;
	}

	public havePreferencesChanged() {
		let preferncesChanged: boolean = true; // to hold flex preferences changes or not
		let swiftPreferencesChanged: boolean = true; // to hold swift preferences changes or not

		// flex prefernces attributes with excluding swift prefernces
		const flexPreferencesAttributeCodes: Array<string> = Object.values(AttributeCode).filter(attr => ![AttributeCode.INVESTMENT_FUND_ALLOCATION, AttributeCode.AUTO_INVESTMENT_FROM_WALLET_TYPE].includes(attr));

		// INFO: Below will filter out swift prefernces for comparing 
		const savedPreferences: Array<object> = {
			...this.previousUserAttribute?.filter(attr => attr.attributeCode !== AttributeCode.INVESTMENT_FUND_ALLOCATION
				&& attr.attributeCode !== AttributeCode.AUTO_INVESTMENT_FROM_WALLET_TYPE)
		};
		let currentPrefernces: InvestmentPreference[] = [];
		currentPrefernces = cloneDeep(this.userAttributes?.filter(attr => flexPreferencesAttributeCodes.includes(attr.attributeCode)).filter(attr => {
			if (attr.attributeValue && attr.attributeCode !== AttributeCode.INVESTMENT_FUND_ALLOCATION && attr.attributeCode !== AttributeCode.AUTO_INVESTMENT_FROM_WALLET_TYPE) {
				return true;
			}
		}));
		currentPrefernces.forEach((attr, index) => {
			currentPrefernces[index].attributeValue = currentPrefernces[index].attributeValue.toString();
		})
		const preferences: any = { ...currentPrefernces };

		// INFO: Below if block will compare swift prefernces only
		if (this.isSwiftEnabled && this.userAttributesSwiftForm.value.fundAllocationPercent.length > 0) {
			const swiftEnabledData = cloneDeep(this.previousUserAttribute?.filter(attr => attr.attributeCode === AttributeCode.AUTO_INVESTMENT_FROM_WALLET_TYPE && attr.attributeValue));
			let savedSwiftAttrs = cloneDeep(this.backupSwiftAttribute);
			let currentSwiftAttrs: InvestmentPreference[] = cloneDeep(this.userAttributesSwiftForm.value.fundAllocationPercent.filter(attr => {
				if (attr.attributeValue) {
					return true
				}
			}));
			// sorting is required because of isEqual compares index and values 
			savedSwiftAttrs = cloneDeep(savedSwiftAttrs.sort((a, b) => {
				let temp1 = String.fromCharCode(parseInt(a?.productCode, 16));
				let temp2 = String.fromCharCode(parseInt(b?.productCode, 16));
				return temp1 < temp2 ? -1 : temp1 > temp2 ? 1 : 0;
			}));
			currentSwiftAttrs = cloneDeep(currentSwiftAttrs.sort((c, d) => {
				let temp1 = String.fromCharCode(parseInt(c?.productCode, 16));
				let temp2 = String.fromCharCode(parseInt(d?.productCode, 16));
				return temp1 < temp2 ? -1 : temp1 > temp2 ? 1 : 0;
			}));
			swiftEnabledData.forEach(data => {
				savedSwiftAttrs.push(data);
				currentSwiftAttrs.push(data);
			});
			currentSwiftAttrs.forEach((attr, index) => {
				currentSwiftAttrs[index].attributeValue = currentSwiftAttrs[index].attributeValue.toString();
			});
			swiftPreferencesChanged = isEqual(savedSwiftAttrs, currentSwiftAttrs);
		}
		else if (!this.isSwiftEnabled) { // if swift disabled 
			const previousSwiftEnabledData = cloneDeep(this.previousUserAttribute?.filter(attr => attr.attributeCode === AttributeCode.AUTO_INVESTMENT_FROM_WALLET_TYPE));
			if (previousSwiftEnabledData?.length) {
				const currentSwiftEnabledData = cloneDeep(this.userAttributes?.filter(attr => attr.attributeCode === AttributeCode.AUTO_INVESTMENT_FROM_WALLET_TYPE));
				swiftPreferencesChanged = isEqual(previousSwiftEnabledData, currentSwiftEnabledData);
			}
		}
		preferncesChanged = isEqual(savedPreferences, preferences);

		return (preferncesChanged === true && swiftPreferencesChanged === true) ? true : false;
	}

	changeDisplaySaveValue(value: boolean) {
		this.disableSave = value;
	}

	/* * * * * * * * * * * * * * * * * * * * *  swift section start * * * * * * * * * * * * * * * * * * * * */

	private setSwiftAttribute() {
		this.isSwiftEnabled = !!this.userAttributes?.find(attribute => attribute.attributeCode === AttributeCode.AUTO_INVESTMENT_FROM_WALLET_TYPE
			&& attribute.attributeValue === AttributeValue.SWIFT);

		if (this.isSwiftEnabled) {
			this.userAttributes.forEach(attribute => {
				if (attribute.attributeCode === AttributeCode.INVESTMENT_FUND_ALLOCATION) {
					if(attribute.productCode === SUB_PRODUCTS.F18) {
						attribute.productCode = MATURITY_PRODUCTS_NAME.F18;
					}
					this.products.push(attribute);
				}
			})
		}
	}


	private allocateFundFormValidator(): ValidatorFn {
		return (formArray: FormArray): any => {
			let totalPercent = 0;
			let isFormValid: boolean = true;
			let shouldContainPositiveValue = true;
			formArray.controls.forEach((element: FormControl) => {
				if (element.value.attributeValue < 0 && element.value.attributeValue !== '' && element.value.attributeValue !== null) {
					shouldContainPositiveValue = false;
				}
				totalPercent = totalPercent + element.value.attributeValue;
			});
			if (!shouldContainPositiveValue) {
				isFormValid = false;
				return isFormValid ? null : { error: 'negativeValueValidatorError' }
			} else {
				isFormValid = totalPercent == 100 ? true : false;
				return isFormValid ? null : { error: 'allocateFundFormValidatorError' };
			}
		};
	}

	private updateSwiftValidators() {
		if (this.isSwiftEnabled) {
			this.userAttributesSwiftForm.controls.fundAllocationPercent.setValidators([this.allocateFundFormValidator()]);
			this.userAttributesSwiftForm.controls.fundAllocationPercent.updateValueAndValidity();
		} else {
			this.userAttributesSwiftForm.controls.fundAllocationPercent.clearValidators();
			this.userAttributesSwiftForm.controls.fundAllocationPercent.updateValueAndValidity();
		}
	}

	private removeSwiftAttribute() {
		this.userAttributes?.forEach(attr => {
			if (attr.attributeCode === AttributeCode.AUTO_INVESTMENT_FROM_WALLET_TYPE ||
				attr.attributeCode === AttributeCode.INVESTMENT_FUND_ALLOCATION)
				attr.attributeValue = null;
		})
	}

	private addSwiftAttribute() {
		this.userAttributes?.push({
			attributeCode: AttributeCode.AUTO_INVESTMENT_FROM_WALLET_TYPE,
			attributeValue: AttributeValue.SWIFT
		})
	}

	public onClickSwiftEditBtn() {
		this.submitBar = true;
		this.disableSave = this.havePreferencesChanged();
		this.isPreviousSwiftAvailable = false;
		this.removeSwiftAttribute();
		this.addSwiftAttribute();
		this.updateSwiftValidators();
	}

	public onSwiftToggle() {
		this.submitBar = true;
		this.isSwiftEnabled = !this.isSwiftEnabled;
		this.isPreviousSwiftAvailable = false;
		this.updateSwiftValidators();
		if (this.isSwiftEnabled) {
			this.addSwiftAttribute();
		} else {
			this.removeSwiftAttribute();
		}
		this.disableSave = this.havePreferencesChanged();
	}

	/* * * * * * * * * * * * * * * * * * * * *  nCash section start * * * * * * * * * * * * * * * * * * * * */

	private async setNCashAttribute() {
		const isNCashAttributeFound = this.userAttributes.find(attr => attr.attributeCode === AttributeCode.NCASH_WD_LIMIT);
		if (!isNCashAttributeFound) {
			UserAttribute.createDefaultNCash().forEach(attr => {
				this.userAttributes.push(attr);
			});
		} else {
			const value = this.userAttributes.find(attr => attr.attributeCode === AttributeCode.NCASH_WD_LIMIT).attributeValue;
			this.selectedNCashType = value.toString();
			this.userPreviousNCashType = value.toString();
			this.setPannel = this.panels.indexOf(this.selectedNCashType);
			this.isNCashEnabled = true;
			this.setNCashValidators();
			this.userAttributesForm.controls.nCash.setValue(value.toString());
			this.userAttributes.forEach(async attribute => {
				switch (attribute.attributeCode) {
					case AttributeCode.NCASH_WD_FREQUENCY:
						this.userAttributesForm.controls.frequency.setValue(attribute.attributeValue);
						this.userPreviousAttributes.push({ key: 'Select Frequency', value: attribute.attributeValue });
						break;

					case AttributeCode.NCASH_WD_AMOUNT:
						this.userPreviousAttributes.push({ key: 'Amount', value: '₹' + formatNumber(attribute.attributeValue, "en-IN", "1.0-2") });
						this.customNCashAmount = Number(attribute.attributeValue);
						break;

					case AttributeCode.NCASH_WD_DATE_OF_MONTH:
						this.userAttributesForm.controls.date.setValue(attribute.attributeValue);
						this.userPreviousAttributes.push({ key: 'Date', value: attribute.attributeValue + 'th of month' });
						break;
				}
			});
			this.setNcashAmount();
		}
	}

	private async setNcashAmount() {
		const nCashType = this.userAttributes?.find((attribute) => attribute?.attributeCode == AttributeCode.NCASH_WD_LIMIT)?.attributeValue;
		if (nCashType != AttributeValue.CUSTOM) {
			const frequency = this.userPreviousAttributes?.find((attribute) => attribute.key == 'Select Frequency')?.value;
			const nCashDate = this.userAttributes?.find(attr => attr.attributeCode === AttributeCode.NCASH_WD_DATE_OF_MONTH).attributeValue;
			await this.nCashCalculatorUtil.getNCashDetailsByLenderId(nCashType, frequency.toString(), nCashDate)
				.then(nCashData => {
					this.maxNCashAmount = nCashData.status === 0 ? nCashData.data[0].ncashAmount : 0;
					const value = formatNumber(this.maxNCashAmount, "en-IN", "1.0-2");
					this.userPreviousAttributes.push({ key: 'Amount', value: '₹' + value });
				}).catch(() => { this.userPreviousAttributes.push({ key: 'Amount', value: '₹' + 0 }) });
		}
	}
	private onNCashPreferenceChange() {
		this.userPreviousNCashType = null;
		this.userAttributes.find(att => att.attributeCode === AttributeCode.NCASH_WD_FREQUENCY).attributeValue = null;
		this.userAttributes.find(att => att.attributeCode === AttributeCode.NCASH_WD_DATE_OF_MONTH).attributeValue = null;
		let NCASH_WD_AMOUNT_PRESENT = this.userAttributes.findIndex(att => att.attributeCode === AttributeCode.NCASH_WD_AMOUNT);
		if (NCASH_WD_AMOUNT_PRESENT >= 0) {
			this.userAttributes[NCASH_WD_AMOUNT_PRESENT].attributeValue = null;
		}
	}

	private onNCashValueChange() {
		this.userAttributesForm.controls.nCash.valueChanges.subscribe(() => this.onNCashPreferenceChange());
	}

	private setNCashValidators() {
		this.userAttributesForm.controls.nCash.setValidators([Validators.required]);
		this.userAttributesForm.controls.frequency.setValidators([Validators.required]);
		this.userAttributesForm.controls.date.setValidators([Validators.required]);
		this.userAttributesForm.reset();
		this.userAttributesForm.updateValueAndValidity();
	}

	private removeNCashValidators() {
		this.userAttributesForm.controls.nCash.clearValidators();
		this.userAttributesForm.controls.frequency.clearValidators();
		this.userAttributesForm.controls.date.clearValidators();
		this.userAttributesForm.reset();
		this.userAttributesForm.updateValueAndValidity();
	}

	public updateSelectedNCashTypeChange() {
		this.submitBar = true;
		this.userAttributes.find(att => att.attributeCode === AttributeCode.NCASH_WD_LIMIT).attributeValue = this.selectedNCashType;
		this.onNCashPreferenceChange();
	}

	public onClickEditBtn() {
		this.submitBar = true;
		this.userPreviousNCashType = null;
		this.disableSave = this.havePreferencesChanged();
	}

	public onNCashToggle() {
		this.submitBar = true;
		this.isNCashEnabled = !this.isNCashEnabled;
		if (this.isNCashEnabled) {
			this.setNCashValidators();
		} else {
			this.removeNCashValidators();
			this.selectedNCashType = null;
			this.userAttributes.find(att => att.attributeCode === AttributeCode.NCASH_WD_LIMIT).attributeValue = null;
			this.onNCashPreferenceChange();
		}
		this.disableSave = this.havePreferencesChanged();
	}

	/* * * * * * * * * * * * * * * * * * * * *  Email notification * * * * * * * * * * * * * * * * * * * * */

	private setEmailNotification() {
		const isEmailEnabled = this.userAttributes.find(attribute => attribute.attributeCode === AttributeCode.EMAIL_NOTIFICATION);
		if (!isEmailEnabled) {
			this.userAttributes.push({
				attributeCode: AttributeCode.EMAIL_NOTIFICATION,
				attributeValue: null
			})
		} else {
			const value = this.userAttributes.find(attr => attr.attributeCode === AttributeCode.EMAIL_NOTIFICATION).attributeValue;
			this.isEmailEnabled = JSON.parse(value.toLowerCase());
		}
	}

	public onEmailToggle() {
		this.submitBar = true;
		this.isEmailEnabled = !this.isEmailEnabled;

		if (this.isEmailEnabled) {
			if (this.userAttributes.find(attr => attr.attributeCode === AttributeCode.EMAIL_NOTIFICATION)) {
				this.userAttributes.find(attr => attr.attributeCode === AttributeCode.EMAIL_NOTIFICATION).attributeValue = true;
			} else {
				this.userAttributes.push({
					attributeCode: AttributeCode.EMAIL_NOTIFICATION,
					attributeValue: "true"
				})
			}
		} else {
			this.userAttributes.splice(this.userAttributes.findIndex(attr => attr.attributeCode === AttributeCode.EMAIL_NOTIFICATION), 1);
		}
		this.disableSave = this.havePreferencesChanged();
	}

	/* * * * * * * * * * * * * * * * * * * * *  Final form submit * * * * * * * * * * * * * * * * * * * * */

	private async getFormSubmitConfirmation(data): Promise<boolean> {
		return this.matDialog.open(ConfirmPopUpFinzyFlexComponent, data).afterClosed().toPromise();
	}

	private async saveUserAttribute(userCurrentAttributes, isFinzyBoltEnabled: boolean) {
		var response: UserAttributeInterface;
		try {
			this.checkNCashModified(this.previousUserAttribute, userCurrentAttributes);
			if (this.isPreferenceExist) {
				this.dataLoader = true;
				response = await this.userAttributeService.putUserAttribute({ investmentPreferences: userCurrentAttributes, automaticInvestmentsFromWallet: isFinzyBoltEnabled, isNCashModified: this.isNCashModified, isSwiftModified: this.checkSwiftModified(userCurrentAttributes) }, this.userId);
			} else {
				this.dataLoader = true;
				response = await this.userAttributeService.postUserAttribute({ investmentPreferences: userCurrentAttributes, automaticInvestmentsFromWallet: isFinzyBoltEnabled, isNCashModified: this.isNCashModified, isSwiftModified: this.checkSwiftModified(userCurrentAttributes) }, this.userId);
			}
			if (response.status === 0) {
				this.dataLoader = false;
				this.submitBar = false;
				Toaster.toast('Preference updated successfully', Type.Success);
				window.location.reload();
			} else {
				this.dataLoader = false;
				Toaster.toast('Failed to update preference. Please try again after sometime.', Type.Error);
			}
		}
		catch (e) {
			this.dataLoader = false;
			Toaster.toast('Something went wrong. Please try again after sometime.', Type.Error);
		}
	}

	private isSwiftConsentRequired(userCurrentAttributes: InvestmentPreference[]): boolean {
		let isSwiftConsentRequired = false;
		const userCurrentSwiftAttribute = userCurrentAttributes.filter(attr => attr.attributeCode === AttributeCode.INVESTMENT_FUND_ALLOCATION);
		if (userCurrentSwiftAttribute.length === 0) return false;
		if (this.backupSwiftAttribute.length === 0 && userCurrentAttributes.length != 0) return true;
		this.backupSwiftAttribute.forEach(attr1 => {
			if (!userCurrentSwiftAttribute.some(attr2 => attr1.productCode === attr2.productCode && attr1.attributeValue === attr2.attributeValue?.toString())) {
				isSwiftConsentRequired = true;
			}
		})
		return isSwiftConsentRequired;
	}

	private showBoltPopupWarning(data): Promise<boolean> {
		return this.matDialog.open(ConfirmationPopupWithSvgComponent, data).afterClosed().toPromise();
	}

	private async showFinzyBoltPopup(userCurrentAttributes) {
		const res = await this.showBoltPopupWarning({
			data: {
				title: 'Switch Off finzyBolt',
				subTitle: '',
				message: `To enable <strong class="black">Swift</strong>, your existing auto investment option(<strong class="black">finzyBolt</strong>) has to be switched off.`,
				positiveButtonText: 'Switch Off',
				negativeButtonText: 'Later',
				image: '../../../../../assets/gif/finzy-flex/switchOffForBolt.svg'
			},
			width: '50%',
			minWidth: '320px',
			panelClass: "confirm-dialog-with-svg-responsive"
		});
		if (res) {
			this.dataLoader = true;
			this.saveUserAttribute(userCurrentAttributes, false);
		} else {
			this.dataLoader = false;
		}
	}

	private checkSwiftModified(userCurrentAttributes: InvestmentPreference[]): boolean {
		const userCurrentSwiftAttribute = userCurrentAttributes.filter(attr => attr.attributeCode === AttributeCode.INVESTMENT_FUND_ALLOCATION);
		if (this.backupSwiftAttribute?.length != 0 && userCurrentSwiftAttribute?.length === 0) return true;
		if (this.backupSwiftAttribute?.length === 0 && userCurrentSwiftAttribute?.length != 0) return true;
		if (this.backupSwiftAttribute?.length === 0 && userCurrentSwiftAttribute.length === 0) return false;
		this.backupSwiftAttribute.forEach(attr1 => {
			if (!userCurrentSwiftAttribute.some(attr2 => attr1.productCode === attr2.productCode && attr1.attributeValue === attr2.attributeValue?.toString())) {
				this.isSwiftModified = true;
			}
		});
		return this.isSwiftModified;
	}

	private checkNCashModified(previousUserAttributes: InvestmentPreference[], userCurrentAttributes: InvestmentPreference[]): boolean {
		let previousNCashAvailable: boolean = false;
		let currentNCashAvailable: boolean = false;
		this.isNCashModified = false;
		previousNCashAvailable = !!previousUserAttributes.find((previousAttribute) => previousAttribute?.attributeCode == AttributeCode.NCASH_WD_LIMIT);
		currentNCashAvailable = !!userCurrentAttributes.find((currentAttribute) => currentAttribute?.attributeCode == AttributeCode.NCASH_WD_LIMIT);
		previousUserAttributes?.forEach((previousAttribute) => {
			if (userCurrentAttributes.some((currentAttribute) =>
				((previousAttribute?.attributeCode == AttributeCode.NCASH_WD_LIMIT && currentAttribute?.attributeCode == AttributeCode.NCASH_WD_LIMIT) && previousAttribute?.attributeValue !== currentAttribute?.attributeValue) ||
				((previousAttribute?.attributeCode == AttributeCode.NCASH_WD_FREQUENCY && currentAttribute?.attributeCode == AttributeCode.NCASH_WD_FREQUENCY) && previousAttribute?.attributeValue !== currentAttribute?.attributeValue) ||
				((previousAttribute?.attributeCode == AttributeCode.NCASH_WD_DATE_OF_MONTH && currentAttribute?.attributeCode == AttributeCode.NCASH_WD_DATE_OF_MONTH) && previousAttribute?.attributeValue !== currentAttribute?.attributeValue) ||
				((previousAttribute?.attributeCode == AttributeCode.NCASH_WD_AMOUNT && currentAttribute?.attributeCode == AttributeCode.NCASH_WD_AMOUNT) && previousAttribute?.attributeValue !== currentAttribute?.attributeValue))) {
				this.isNCashModified = true;
			}
		});
		if (previousNCashAvailable !== currentNCashAvailable) {
			this.isNCashModified = true;
		}
		return this.isNCashModified;
	}

	public async submit() {
		if (this.isSwiftEnabled) {
			this.userAttributesSwiftForm.controls.fundAllocationPercent.value.forEach(fundAllocation => {
				this.userAttributes.push(fundAllocation);
			})
		}
		const userCurrentAttributes = this.userAttributes.filter(attr => attr.attributeValue !== null);
		if (this.isSwiftConsentRequired(userCurrentAttributes)) {
			const isConsentsTaken = await this.matDialog.open(ConsentDialogComponent, { panelClass: ["dialog-responsive", "consent-dialog"], width: '90%', maxWidth: '950px' }).afterClosed().toPromise();
			if (isConsentsTaken && !this.isFinzyBoltEnabled) {
				await this.consentService.saveConsent(ConsentType.LENDER_SWIFT_AGREEMENT_REVIEWED)
					.then(async () => await this.saveUserAttribute(userCurrentAttributes, this.isFinzyBoltEnabled))
					.catch(() => Toaster.toast('Something went wrong while saving the preferences', Type.Error));
			} else if (this.isFinzyBoltEnabled) {
				await this.showFinzyBoltPopup(userCurrentAttributes);
			}
			else {
				this.userAttributes = this.userAttributes.filter(attr => attr.attributeCode !== AttributeCode.INVESTMENT_FUND_ALLOCATION);
			}
		} else {
			const res = await this.getFormSubmitConfirmation({
				data: {
					title: 'Do you want to continue',
					subTitle: 'You have made changes to yours preference',
					message: `By clicking on <strong class='black'>CONTINUE</strong> your existing preference will be reset and accordingly the nCASH payout amount and nCASH payout date will change to the following period. You would not be able to reverse the change.`,
					positiveButtonText: 'CONTINUE',
					negativeButtonText: 'BACK'
				},
				width: '50%',
				minWidth: '320px',
				panelClass: "confirm-dialog-responsive"
			});
			if (res) {
				await this.saveUserAttribute(userCurrentAttributes, this.isFinzyBoltEnabled);
			} else {
				window.location.reload();
			}
		}
	}
	public async setUpLater() {
		const res = await this.getFormSubmitConfirmation({
			data: {
				title: 'Do you want to continue',
				subTitle: 'Your preference set up is incomplete',
				message: `<span class='grey'>Click on <strong class='black'> Set Up Now </strong> to continue setting up preferences. You can click on <strong class='black'> Set Up Later </strong> to set the preferences later.</span>`,
				positiveButtonText: 'Set Up Later',
				negativeButtonText: 'Set Up Now'
			},
			width: '50%',
			minWidth: '320px',
			panelClass: "confirm-dialog-responsive"
		});
		if (res) {
			window.location.reload();
		}

	}

	/**************************** Loan Tenure Preference start ***********************/
	public setLoanPreferencesDefaultValues() {
		let riskRange: Array<string> = [];
		this.userAttributes.forEach(async attribute => {
			switch (attribute.attributeCode) {
				case AttributeCode.PREFERRED_LOAN_TENURE:
					this.userAttributesForm.get("loanPreference.tenurePreference").setValue(attribute.attributeValue);
					this.tenurePreferenceToggle = attribute.attributeValue;
					break;

				case AttributeCode.PREFERRED_MAX_LOAN_ALLOCATION_AMOUNT_PERCENTAGE:
					this.userAttributesForm.get("loanPreference.maxLoanAmount").setValue(attribute.attributeValue);
					this.maxLoanAmountToggle = attribute.attributeValue;
					break;

				case AttributeCode.FLEX_PREFERRED_RATING_LOW_RISK:
				case AttributeCode.FLEX_PREFERRED_RATING_MEDIUM_RISK:
				case AttributeCode.FLEX_PREFERRED_RATING_HIGH_RISK:
					riskRange.push(attribute.attributeValue)
					this.userAttributesForm.get("loanPreference.interestRateRiskRange").setValue(riskRange);
					this.interestRateRiskRangeToggle = riskRange;
					break;
			}
		});

		if (!this.userAttributesForm.get("loanPreference.maxLoanAmount").value) {
			this.userAttributesForm.get("loanPreference.maxLoanAmount").setValue(this.maxLoanAmountToggle);
			this.userAttributes.push({
				attributeCode: AttributeCode.PREFERRED_MAX_LOAN_ALLOCATION_AMOUNT_PERCENTAGE,
				attributeValue: this.maxLoanAmountToggle
			});
			this.submitBar = true;
			this.disableSave = this.havePreferencesChanged();
		}

		if (!this.userAttributesForm.get("loanPreference.tenurePreference").value) {
			this.userAttributesForm.get("loanPreference.tenurePreference").setValue(this.tenurePreferenceToggle);
			this.userAttributes.push({
				attributeCode: AttributeCode.PREFERRED_LOAN_TENURE,
				attributeValue: this.tenurePreferenceToggle
			});
			this.submitBar = true;
			this.disableSave = this.havePreferencesChanged();
		}

		if (!Array.isArray(this.userAttributesForm.get("loanPreference.interestRateRiskRange").value)) {
			this.userAttributesForm.get("loanPreference.interestRateRiskRange").setValue(Object.values(RISK_RANGE));
			const event = { value: Object.values(RISK_RANGE) };
			this.userAttributes.push(
				{
					attributeCode: AttributeCode.FLEX_PREFERRED_RATING_LOW_RISK,
					attributeValue: RISK_RANGE.A1_A6
				},
				{
					attributeCode: AttributeCode.FLEX_PREFERRED_RATING_MEDIUM_RISK,
					attributeValue: RISK_RANGE.B1_B6
				},
				{
					attributeCode: AttributeCode.FLEX_PREFERRED_RATING_HIGH_RISK,
					attributeValue: RISK_RANGE.C1_C6
				}
			);
			this.interestRateChange(event, false);
			this.submitBar = true;
			this.disableSave = this.havePreferencesChanged();
		} else {
			const event = { value: this.userAttributesForm.get("loanPreference.interestRateRiskRange").value };
			this.interestRateChange(event, false);
		}
	}

	public maxLoanAmountChange(event: any) {
		const selectedValue = event.value;
		this.userAttributesForm.get("loanPreference.maxLoanAmount").setValue(selectedValue);
		if (selectedValue) {
			this.submitBar = true;
			this.userAttributes.find(attr => attr.attributeCode === AttributeCode.PREFERRED_MAX_LOAN_ALLOCATION_AMOUNT_PERCENTAGE).attributeValue = selectedValue;
		}
		this.disableSave = this.havePreferencesChanged();
	}

	public preferredTenureChange(event: any) {
		const selectedValue = event.value;
		this.userAttributesForm.get("loanPreference.tenurePreference").setValue(selectedValue);
		if (selectedValue) {
			this.submitBar = true;
			this.userAttributes.find(attr => attr.attributeCode === AttributeCode.PREFERRED_LOAN_TENURE).attributeValue = selectedValue;
		}
		this.disableSave = this.havePreferencesChanged();
	}

	public interestRateChange(event: any, isComingFromForm?: boolean) {
		const selectedRiskLevels: Array<string> = event.value;

		if (Array.isArray(selectedRiskLevels)) {
			this.userAttributesForm
				.get("loanPreference.interestRateRiskRange")
				.setValue(selectedRiskLevels);

			if (this.getScores(selectedRiskLevels)) {
				this.expectedReturn.F6 = this.riskScore.F6 ? this.riskScore.F6[this.getScores(selectedRiskLevels)] : 0;
				this.expectedReturn.F12 = this.riskScore.F12 ? this.riskScore.F12[this.getScores(selectedRiskLevels)] : 0;
				this.expectedReturn.F24 = this.riskScore.F24 ? this.riskScore.F24[this.getScores(selectedRiskLevels)] : 0;
				this.expectedReturn.F36 = this.riskScore.F36 ? this.riskScore.F36[this.getScores(selectedRiskLevels)] : 0;
				this.expectedReturn.F18 = this.riskScore.F18 ? this.riskScore.F18[this.getScores(selectedRiskLevels)] : 0;
			}
			else {
				this.expectedReturn.F6 = 0;
				this.expectedReturn.F12 = 0;
				this.expectedReturn.F24 = 0;
				this.expectedReturn.F36 = 0;
				this.expectedReturn.F18 = 0;
			}

			this.userAttributesForm
				.get("loanPreference.expectedReturn.F6")
				.setValue(this.expectedReturn.F6);
			this.userAttributesForm
				.get("loanPreference.expectedReturn.F12")
				.setValue(this.expectedReturn.F12);
			this.userAttributesForm
				.get("loanPreference.expectedReturn.F24")
				.setValue(this.expectedReturn.F24);
			this.userAttributesForm
				.get("loanPreference.expectedReturn.F36")
				.setValue(this.expectedReturn.F36);
			this.userAttributesForm
				.get("loanPreference.expectedReturn.F18")
				.setValue(this.expectedReturn.F18);

			if (selectedRiskLevels && isComingFromForm) {
				this.submitBar = true;
				const preferredLowRiskRating: InvestmentPreference = this.userAttributes.find(attr => attr.attributeCode === AttributeCode.FLEX_PREFERRED_RATING_LOW_RISK);
				if (preferredLowRiskRating && !selectedRiskLevels.includes(RISK_RANGE.A1_A6)) {
					this.userAttributes.splice(this.userAttributes.findIndex(attr => attr.attributeCode === AttributeCode.FLEX_PREFERRED_RATING_LOW_RISK), 1);
				} else if (!preferredLowRiskRating && selectedRiskLevels.includes(RISK_RANGE.A1_A6)) {
					this.userAttributes.push({
						attributeCode: AttributeCode.FLEX_PREFERRED_RATING_LOW_RISK,
						attributeValue: RISK_RANGE.A1_A6
					});
				};

				const preferredMediumRiskRating: InvestmentPreference = this.userAttributes.find(attr => attr.attributeCode === AttributeCode.FLEX_PREFERRED_RATING_MEDIUM_RISK);
				if (preferredMediumRiskRating && !selectedRiskLevels.includes(RISK_RANGE.B1_B6)) {
					this.userAttributes.splice(this.userAttributes.findIndex(attr => attr.attributeCode === AttributeCode.FLEX_PREFERRED_RATING_MEDIUM_RISK), 1);
				} else if (!preferredMediumRiskRating && selectedRiskLevels.includes(RISK_RANGE.B1_B6)) {
					this.userAttributes.push({
						attributeCode: AttributeCode.FLEX_PREFERRED_RATING_MEDIUM_RISK,
						attributeValue: RISK_RANGE.B1_B6
					});
				};

				const preferredHighRiskRating: InvestmentPreference = this.userAttributes.find(attr => attr.attributeCode === AttributeCode.FLEX_PREFERRED_RATING_HIGH_RISK);
				if (preferredHighRiskRating && !selectedRiskLevels.includes(RISK_RANGE.C1_C6)) {
					this.userAttributes.splice(this.userAttributes.findIndex(attr => attr.attributeCode === AttributeCode.FLEX_PREFERRED_RATING_HIGH_RISK), 1);
				} else if (!preferredHighRiskRating && selectedRiskLevels.includes(RISK_RANGE.C1_C6)) {
					this.userAttributes.push({
						attributeCode: AttributeCode.FLEX_PREFERRED_RATING_HIGH_RISK,
						attributeValue: RISK_RANGE.C1_C6
					});
				};
			}
		}

		this.disableSave = this.havePreferencesChanged();
		this.showFormPreferenceForm = true;
	}

	public getProductFromRiskScore() {
		const sortedKeys: Array<string> = Object.keys(this.riskScore).sort((a, b) => {
			const sumA = Object.values(this.riskScore[a]).reduce((acc, curr) => acc + curr, 0);
			const sumB = Object.values(this.riskScore[b]).reduce((acc, curr) => acc + curr, 0);
			return sumA - sumB;
		});
		return sortedKeys;
	}

	public getProductCodeVariantCategory(productCode: string, value: number): { productCode: string, category: string } {
		switch (productCode) {
			case 'F6':
			case 'F12':
				switch (value) {
					case 9:
						return {productCode, category: null}
					case 6.05:
						return {productCode, category: 'C1'}
					case 4.09:
						return {productCode, category: 'C2'}
					default:
						return {productCode, category: null}
				}
			case 'F24':
				switch (value) {
					case 9:
						return {productCode, category: null}
					case 7.92:
						return {productCode, category: 'C1'}
					case 5.56:
						return {productCode, category: 'C2'}
					default:
						return {productCode, category: null}
				}
			case 'F36':
				switch (value) {
					case 9:
						return {productCode, category: null}
					case 9.01:
						return {productCode, category: 'C1'}
					case 6.12:
						return {productCode, category: 'C2'}
					default:
						return {productCode, category: null}
				}
			default:
				return {productCode, category: null};
		}
	}

	private getScores(riskRangeArray: Array<string>): number {
		let scores: number = 0;
		riskRangeArray.forEach(range => {
			scores = this.riskRangeScore[range] + scores;
		});
		return scores;
	}

	private async getRiskScore(): Promise<void> {
		const lenderId: string = this.storageService.getItem(Keys.LENDER_ID);
		this.productService.getRiskScore(lenderId)
			.then((res) => {
				this.riskScore = res;
				this.setLoanPreferencesDefaultValues();
			})
			.catch((err) => {
				console.log(err)
			})
	}
	/**************************** Loan Tenure Preference start ***********************/

}
